<template>
    <div class="slide get-started">

        <div class="start-logo" style="background-image: url('/assets/img/questionnaire-header.png')">

            <img src="/assets/img/logo-header.svg" />

        </div>

        <div class="start-content">

            <span class="start-title">
                Ok, let’s get to work.
            </span>

            <span class="start-subtitle">
                I have a few questions that will help me get to know you better. Ready to get started? I am.
            </span>

            <button class="start-btn" @click="next">
                Yes! Let's do it!
            </button>

        </div>

    </div>
</template>

<script>
export default {
    name: 'GetStarted',
    methods: {
        next() {
            this.$router.push({ name: 'PersonOneWorkingRetired' })
        }
    }
}
</script>